
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sneakers/skateboarding",
      function () {
        return require("private-next-pages/sneakers/skateboarding.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sneakers/skateboarding"])
      });
    }
  